import clsx from "clsx";
import React from "react";

import MaterialGrid from "@material-ui/core/Grid";
import { excludeKeys, makeThemedStyles } from "qpr-base/viewcomponents/utils";

const useStylesForKPIDetailsMetadataContainer = makeThemedStyles(
  "KPIDetailsContent.KPIDetailsMetadataContainer",
  (theme) => ({
    KPIDetailsMetadataContainer: {},
  })
);

type PropType = React.ComponentProps<typeof MaterialGrid>;

export const KPIDetailsMetadataContainer: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForKPIDetailsMetadataContainer();

  const enabledClasses = excludeKeys(styles, ["KPIDetailsMetadataContainer"]);

  /* eslint-disable */
  return (
    <MaterialGrid
      {...props}
      classes={{
        root: styles.KPIDetailsMetadataContainer,
        ...enabledClasses,
      }}
      className={clsx(styles.KPIDetailsMetadataContainer)}
    >
      {props?.children}
    </MaterialGrid>
  );
};
export default KPIDetailsMetadataContainer;
